<template>
  <b-container fluid>
    <b-row class="justify-content-center mt-3">
      <b-col md="8">
        <b-button
          class="right-button"
          variant="primary"
          :to="{ name: 'note_edit', params: { noteId: 'new' } }"
        >
          Skapa Ny Anteckning
        </b-button>
        <h1 v-if="groupId == 'all'">Anteckningar</h1>
        <h1 v-else>Anteckningar i {{ noteGroup.title }}</h1>
        <b-table hover :fields="fields" :items="filteredNotes">
          <template v-slot:cell(title)="data">
            {{ data.item.title }}
          </template>
          <template v-slot:cell(author)="data">
            {{ employeeName(data.item.author) }}
          </template>
          <template v-slot:cell(date)="data">
            {{
              new Date(data.item.update_time).toLocaleTimeString("sv-SE", {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
            }}
          </template>

          <template v-slot:cell(buttons)="data">
            <b-button-group>
              <b-button
                variant="primary"
                :to="{ name: 'note', params: { noteId: data.item.id.toString() } }"
              >
                Visa
              </b-button>
              <b-button
                variant="warning"
                :to="{ name: 'note_edit', params: { noteId: data.item.id.toString() } }"
              >
                Editera
              </b-button>
              <b-button v-if="false" variant="danger" @click="handleDelete(data.item)">
                Radera
              </b-button>
            </b-button-group>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { noteService, noteGroupService, employeeService } from "../_services";

export default {
  name: "notesPage",
  props: {
    groupId: {
      type: String,
    },
  },
  data() {
    return {
      notes: [],
      noteGroup: {},
      employees: undefined,
      fields: [
        { key: "title", label: "Titel" },
        { key: "author", label: "Författare" },
        { key: "date", label: "Datum" },
        { key: "buttons", label: "" },
      ],
    };
  },
  computed: {
    employee() {
      return this.$store.getters["employee/employee"];
    },
    filteredNotes() {
      if (this.groupId == "all") {
        return this.notes;
      }
      return this.notes.filter((item) => {
        if (item.group == this.groupId) {
          return true;
        }
        return false;
      });
    },
  },
  created() {
    var self = this;
    self.fetch();
  },
  methods: {
    async fetch() {
      var self = this;
      self.employees = await employeeService.getAll();
      try {
        noteService.getAll().then(function (result) {
          self.notes = result;
        });
      } catch (err) {
        console.error("Caught error");
        console.error(err);
      }
      self.noteGroup = await noteGroupService.get(self.groupId);
    },
    employeeName(employeeId) {
      var self = this;
      var employee = self.employees.find((x) => x.id === employeeId);
      if (employee) {
        return employee.user.firstname + " " + employee.user.surname;
      }
      return "";
    },
    handleDelete(note) {
      console.debug(note);
      // #TODO
    },
  },
};
</script>
